import markApplyRecordService from "./markApplyRecordService";

const cropMarkApplyRecordService = [
    ...markApplyRecordService
]

export default cropMarkApplyRecordService;